import React from 'react'
import { ImageListItemBar, styled } from '@mui/material'
import { ImageGridItemBarProps } from './type'
import { FunctionField, RaRecord, sanitizeFieldRestProps } from 'react-admin'
import { ChipGroupStatus } from '../chip'

const ImageGriditemBarStyled = styled(ImageListItemBar)(() => ({
  background: 'transparent',
}))

export const ImageGriditemBar: React.FC<ImageGridItemBarProps> = ({
  publishedSource = 'is_published',
  approvedSource = 'is_approved',
  activeSource = 'is_active',
  // approvedSource = 'is_approved',
  highlightSource = 'is_highlight',
  expiredSource = 'end_date',
  ...props
}) => {
  const render = (record: RaRecord): JSX.Element => {
    if (!record) return null
    return (
      <ImageGriditemBarStyled
        position='top'
        title={
          <ChipGroupStatus
            record={record}
            publishedSource={publishedSource}
            approvedSource={approvedSource}
            highlightSource={highlightSource}
            expiredSource={expiredSource}
            activedSource={activeSource}
          />
        }
        {...sanitizeFieldRestProps(props)}
      ></ImageGriditemBarStyled>
    )
  }
  return <FunctionField render={render} {...props} />
}
